import { Link } from 'react-router-dom';
import { HERO } from '../constants/content';
import { SITE_NAME, SITE_TAGLINE } from '../constants/site';
import TopBar from '../components/TopBar';

export default function HomePage() {
  return (
    <div className="page page--hero">
      <div className="hero">
        <div className="hero__bg" aria-hidden="true">
          <span className="hero__orb hero__orb--a" />
          <span className="hero__orb hero__orb--b" />
          <span className="hero__orb hero__orb--c" />
          <span className="hero__mesh" />
          <span className="hero__ring hero__ring--a" />
          <span className="hero__ring hero__ring--b" />
          <span className="hero__leaf hero__leaf--1" />
          <span className="hero__leaf hero__leaf--2" />
          <span className="hero__leaf hero__leaf--3" />
          <span className="hero__leaf hero__leaf--4" />
        </div>
        <TopBar />
        <div className="hero__inner">
          <p className="hero__eyebrow fade-up">{SITE_TAGLINE}</p>
          <h1 className="hero__brand fade-up fade-up-delay-1">{SITE_NAME}</h1>
          <p className="hero__headline fade-up fade-up-delay-2">{HERO.headline}</p>
          <p className="hero__support fade-up fade-up-delay-2">{HERO.support}</p>
          <ul className="hero__list fade-up fade-up-delay-3">
            {HERO.bullets.map((item) => (
              <li key={item}>{item}</li>
            ))}
          </ul>
          <div className="hero__actions fade-up fade-up-delay-3">
            <Link to="/updating" className="btn btn--primary">
              {HERO.cta}
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}
